"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userProfileDemographicsFactory = void 0;
const Factory = require("factory.ts");
const Profiles_1 = require("../Profiles");
exports.userProfileDemographicsFactory = Factory.Sync.makeFactory({
    id: `user-profile-${Factory.each(i => i + 1)}`,
    access: 'viewer',
    relationship: 'other',
    persona_listener_id: null,
    persona: Profiles_1.personaFactory.build(),
    demographics: Profiles_1.PersonaDemographicsFactory.build(),
});
